module.exports = __webpack_public_path__ + "static/media/8.307e3ddb.webp";